import { render, staticRenderFns } from "./AiReport.vue?vue&type=template&id=7939d1ea&scoped=true"
import script from "./AiReport.vue?vue&type=script&setup=true&lang=js"
export * from "./AiReport.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939d1ea",
  null
  
)

export default component.exports